import { useQuery } from 'src/shared/lib/useQuery';
import { genQueryKey } from 'src/shared/lib/query.utils';
import { QueryResult } from 'src/shared/types/util.types';
import { useOrg } from 'src/shared/contexts/OrgContext';
import { ClassificationModel } from 'src/shared/types/classification-model.types';

export function useClassificationModel(modelId?: string): QueryResult<ClassificationModel> {
  const { orgFetch, currentOrg } = useOrg();

  const queryKey = ['next-gen', 'classification-models', modelId, genQueryKey(currentOrg.id)];

  return useQuery({
    queryFn: getData,
    queryKey: queryKey,
    enabled: !!modelId,
    staleTime: 0,
  });

  async function getData() {
    const res = await orgFetch<ClassificationModel>(`/api/v2/next-gen-models/classification/${modelId}`);
    if (!res.ok) {
      throw new Error('Failed to fetch classification model');
    }
    const model = await res.json();

    return model;
  }
}
